import { render, staticRenderFns } from "./LayoutInfo.vue?vue&type=template&id=3aadd556&scoped=true"
import script from "./LayoutInfo.vue?vue&type=script&lang=js"
export * from "./LayoutInfo.vue?vue&type=script&lang=js"
import style0 from "./LayoutInfo.vue?vue&type=style&index=0&id=3aadd556&prod&lang=css"
import style1 from "./LayoutInfo.vue?vue&type=style&index=1&id=3aadd556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aadd556",
  null
  
)

export default component.exports